import { Component, OnInit, ViewChild } from '@angular/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { UsersService } from '../users/users.service';
import { DialogService } from 'primeng/dynamicdialog';
import { MeetingsService } from '../organizations/organizations-detail/organizations-meetings-detail/meetings.service';
import { MessageService } from 'primeng/api';
import { Input, Output } from '@angular/core';
import esLocale from '@fullcalendar/core/locales/es';
import { OrganizationsMeetingsDetailComponent } from '../organizations/organizations-detail/organizations-meetings-detail/organizations-meetings-detail.component';
import { Inject } from '@angular/core';
import { LoginService } from '../login/login.service';
import { FullCalendarComponent } from '@fullcalendar/angular';

@Component({
  selector: 'app-user-calendar',
  templateUrl: './user-calendar.component.html',
  styleUrls: ['./user-calendar.component.scss']
})
export class UserCalendarComponent implements OnInit {
  @ViewChild(FullCalendarComponent) fullCalendar: FullCalendarComponent;
  @Input("user_id") public user_id: number = null;
  @Input("height") public height: any = 250;

  public currentDate: Date = new Date();
  public user: any = null;
  public selectedUsers: number[] = [];

  public events: any[] = [];
  public from_date: Date = null;
  public to_date: Date = null;
  public tooltip_info = {
    show: false,
    description: "",
    showType: "",
    date_from: "",
    responsible: "",
    organization: "",
    duration: "",
    allDay: false,
  };
  public xPos = "0px";
  public yPos = "0px";
  public options: any = {
    locale: esLocale,
    plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
    initialView: 'timeGridDay',
    defaultDate: this.currentDate,
    height: this.height,
    headerToolbar: {
      left: 'prev',
      center: 'title',
      right: 'next'
    },
    titleFormat: { // will produce something like "Tuesday, September 18, 2018"
      month: 'short',
      year: 'numeric',
      day: 'numeric'
    },
    dateClick: (date) => {
      //console.log(this.parent, this.parent.meeting);
      this.parent.meeting.from = date.date;
    },
    datesSet: (e) => {
      this.handleDatesRender(e);
    },

    eventMouseEnter: (e) => {
      window.addEventListener("mousemove", (e) => {
        this.xPos = (e.clientX + 46) + "px";
        this.yPos = (e.clientY + 32) + "px";
      });
      this.tooltip_info.description = e.event._def.title;
      this.tooltip_info.show = true;
      this.tooltip_info.showType = e.event._def.extendedProps.showType;
      this.tooltip_info.date_from = (e.event._def.allDay != true ? e.event._def.extendedProps.date_from : "");
      this.tooltip_info.responsible = e.event._def.extendedProps.responsible;
      this.tooltip_info.organization = e.event._def.extendedProps.organization;
      this.tooltip_info.duration = (e.event._def.allDay == true ? "Todo el día" : this.getTimeOfEvent(e.event._def.extendedProps.duration));
      this.tooltip_info.allDay = e.event._def.allDay;

    },
    eventMouseLeave: (e) => {
      this.tooltip_info.show = false;
    },
    eventTimeFormat: {
      hour: '2-digit',
      minute: '2-digit',
      meridiem: false
    },
    editable: false,
    selectable: true
  };

  constructor(
    private meetingsService: MeetingsService,
    private usersService: UsersService,
    private dialogService: DialogService,
    private messageService: MessageService,
    private loginService: LoginService,
    @Inject(OrganizationsMeetingsDetailComponent) private parent: OrganizationsMeetingsDetailComponent
  ) { }

  ngOnInit(): void {
    this.options.height = this.height;
    this.loadUser();
  }

  setDate(date: Date) {
    this.options.defaultDate = date;
    this.fullCalendar.getApi().gotoDate(date);
  }

  loadUser() {
    this.usersService.get(this.loginService.get("userId")).subscribe(
      data => {
        this.user = data;
        this.selectedUsers = this.user.metadata?.calendarConfig?.selectedUsers;
        if (this.selectedUsers == null || this.selectedUsers.length == 0) this.selectedUsers = [parseInt(localStorage.getItem("userId"))];
        this.loadMeetings();
      },
      error => this.messageService.add({ closable: false, severity: "error", detail: error.error.title })
    );
  }

  loadMeetings() {
    let parameters: any = {
      check_invited_users: true, //busca tambien en invitados
      from_date: this.from_date.toISOString(),
      to_date: this.to_date.toISOString()
    };
    if (this.selectedUsers != null && this.selectedUsers.length > 0) {
      Object.assign(parameters, { usersIds: this.selectedUsers });
    } else {
      Object.assign(parameters, { usersIds: [parseInt(localStorage.getItem("userId"))] });
    }

    this.meetingsService.all(parameters).subscribe(
      data => {
        this.events = data.rows.map(m => {
          return {
            title: m.subject,
            start: m.from,
            end: m.to,
            event_id: m.id,
            date_from: m.from,
            type: 'meeting',
            showType: "Reunión",
            responsible: m.responsible?.name,
            organization: m.organization?.name,
            duration: m.duration,
            backgroundColor: m.responsible.color ? m.responsible.color : "#e8e8e8",
            textColor: "black",
            allDay: m.allDay,
            
          };
        });
      },
      error => this.messageService.add({ closable: false, severity: "error", detail: error.error.title })
    );
  }

  handleDatesRender($event) {
    //this.parent.meeting.from = $event.view.calendar.state.currentDate;
    this.from_date = $event.start;
    this.to_date = $event.end;
    this.loadMeetings();
  }

  getTimeOfEvent(duration) {
    //Éste método devuelve una cadena de texto con la duración del evento en el formato X h XX m.

    var durationText = "";
    if (duration >= 60) {
      var hours = Math.floor(duration / 60);
      var minutes = duration % 60;
      if (hours === 1) {
        //Si se necesita, se puede poner aquí "hora":
        durationText = "1 h";
      } else {
        //Si se necesita, se puede poner aquí "horas":
        durationText = hours + " h";
      }
      if (minutes > 0) {
        durationText += " ";
        if (minutes === 1) {
          //Si se necesita, se puede poner aquí "minuto":
          durationText += "1 min.";
        } else {
          //Si se necesita, se puede poner aquí "minutos":
          durationText += minutes + " min.";
        }
      }
    } else {
      //Si se necesita, se puede poner aquí "minutos":
      durationText = duration + " min.";
    }
    return durationText;
  }
}
